import styled from 'styled-components'
import { AsyncButton, Skeleton } from '@sketch/components'
import { MarkAsReadIcon } from 'modules/activity/components/Notifications/NotificationListItem.styles'

export const Wrapper = styled.div`
  flex: 1;
  max-width: 660px;
`
export const WrapperList = styled.div`
  flex: 1;
  max-width: 100%;
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`

export const MarkAllAsReadButton = styled(AsyncButton).attrs({ size: '32' })`
  margin-left: auto;
  margin-right: 8px;
`

export const StyledMarkAsReadIcon = styled(MarkAsReadIcon)`
  margin-right: 8px;
`

export const StyledSkeleton = styled(Skeleton)`
  margin-left: auto;
  margin-right: 8px;
`
